export interface SiteConfig {
  brand: {
    name: string;
    tagline: string;
    taglineHi: string;
    logo: string;
  };
  theme: {
    primaryColor: string;
    primaryColorDark: string;
    secondaryColor: string;
    secondaryColorDark: string;
    accentColor: string;
    accentColorDark: string;
  };
  contact: {
    phone: string;
    whatsapp: string;
    email: string;
    address: string;
    addressHi: string;
    mapsUrl: string;
    mapsEmbedUrl: string;
  };
  social: {
    facebook: string;
    instagram: string;
    youtube: string;
    twitter: string;
  };
  business: {
    hours: string;
    hoursHi: string;
  };
  siteUrl: string;
  formEndpoint: string;
}

const config: SiteConfig = {
  brand: {
    name: import.meta.env.VITE_BRAND_NAME || 'MyShop',
    tagline: import.meta.env.VITE_BRAND_TAGLINE || 'Your One-Stop Stationery & Digital Services Center',
    taglineHi: import.meta.env.VITE_BRAND_TAGLINE_HI || 'आपका एक-स्टॉप स्टेशनरी और डिजिटल सेवा केंद्र',
    logo: import.meta.env.VITE_BRAND_LOGO || '/images/logo.svg',
  },
  theme: {
    primaryColor: import.meta.env.VITE_PRIMARY_COLOR || '#2563eb',
    primaryColorDark: import.meta.env.VITE_PRIMARY_COLOR_DARK || '#1d4ed8',
    secondaryColor: import.meta.env.VITE_SECONDARY_COLOR || '#059669',
    secondaryColorDark: import.meta.env.VITE_SECONDARY_COLOR_DARK || '#047857',
    accentColor: import.meta.env.VITE_ACCENT_COLOR || '#f59e0b',
    accentColorDark: import.meta.env.VITE_ACCENT_COLOR_DARK || '#d97706',
  },
  contact: {
    phone: import.meta.env.VITE_CONTACT_PHONE || '+919876543210',
    whatsapp: import.meta.env.VITE_CONTACT_WHATSAPP || '919876543210',
    email: import.meta.env.VITE_CONTACT_EMAIL || 'info@myshop.com',
    address: import.meta.env.VITE_CONTACT_ADDRESS || '123 Main Street, City, State 110001',
    addressHi: import.meta.env.VITE_CONTACT_ADDRESS_HI || '123 मुख्य सड़क, शहर, राज्य 110001',
    mapsUrl: import.meta.env.VITE_CONTACT_MAPS_URL || 'https://maps.google.com',
    mapsEmbedUrl: import.meta.env.VITE_CONTACT_MAPS_EMBED_URL || '',
  },
  social: {
    facebook: import.meta.env.VITE_SOCIAL_FACEBOOK || '',
    instagram: import.meta.env.VITE_SOCIAL_INSTAGRAM || '',
    youtube: import.meta.env.VITE_SOCIAL_YOUTUBE || '',
    twitter: import.meta.env.VITE_SOCIAL_TWITTER || '',
  },
  business: {
    hours: import.meta.env.VITE_BUSINESS_HOURS || 'Mon-Sat: 9:00 AM - 8:00 PM',
    hoursHi: import.meta.env.VITE_BUSINESS_HOURS_HI || 'सोम-शनि: सुबह 9:00 - शाम 8:00',
  },
  siteUrl: import.meta.env.VITE_SITE_URL || 'https://kaamkaajonline.shop',
  formEndpoint: import.meta.env.VITE_FORM_ENDPOINT || '',
};

export function injectThemeColors(): void {
  const root = document.documentElement;
  root.style.setProperty('--brand-primary', config.theme.primaryColor);
  root.style.setProperty('--brand-primary-dark', config.theme.primaryColorDark);
  root.style.setProperty('--brand-secondary', config.theme.secondaryColor);
  root.style.setProperty('--brand-secondary-dark', config.theme.secondaryColorDark);
  root.style.setProperty('--brand-accent', config.theme.accentColor);
  root.style.setProperty('--brand-accent-dark', config.theme.accentColorDark);
}

export default config;
